<!--
 * @Author: cmchiu
 * @Date: 2023-04-12 11:09:50
 * @LastEditTime: 2023-04-27 11:12:36
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \IACMP\IACMP_Client\src\components\Entries\entries.vue
 * 
-->
<template>
    <div class="entries w-100">
        <h2 class="sub-title">快速入口</h2>
        <div class="entries__content w-100 d-flex justify-content-center">
            <div class="entries__set d-flex flex-wrap justify-content-center">
                <router-link
                    v-for="item in menuLs"
                    :key="item.sno"
                    :to="{
                        path: `/${item.MenuPath}${
                            ['page', 'files', 'posts'].includes(item.ItemType) ? '?id=' + item.MenuID : ''
                        }`,
                    }"
                    class="entries__item d-flex justify-content-center flex-wrap"
                >
                    <img class="entries__img" :src="item.ItemIcon" alt="" />
                    <h3 class="entries__title" v-text="item.MenuTitle"></h3>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { getMenu } from '@/api/common'

export default {
    name: 'cEntries',

    data() {
        return {
            configs: {
                loading: false,
            },
            menuLs: [],
        }
    },

    created() {
        this.getMenu()
    },

    methods: {
        async getMenu() {
            const vm = this
            vm.configs.loading = true
            await getMenu({ ft: true })
                .then(res => {
                    // handle success
                    // vm.routes = res.Items
                    vm.menuLs = res.Items
                })
                .catch(err => {
                    // handle error
                    vm.menuLs = []
                    console.log(err)
                })
                .finally(() => {
                    // always executed
                    vm.configs.loading = false
                })
        },
    },
}
</script>
